
import React, { Component } from 'react'
import {base} from 'settings/global'

import {HomeBanner} from './HomeBanner'
import './QuickBorrow.scss'

import { jkUrl } from 'settings';

class QuickBorrow extends Component {

  render() {
    return (
      <div className="silderCon" id="silderCon">
        <HomeBanner banner={this.props.banner}/>
      </div>
    )
  }
}

export { QuickBorrow }



// WEBPACK FOOTER //
// ./modules/home/QuickBorrow.js